import {
  CandidateEntity,
  CompanyEntity,
  EntityType,
  HiringAuthorityEntity
} from 'UI/constants/entityTypes';

export const buildRelatedEntities = results => {
  if (!results) return [];

  return [
    {
      title: HiringAuthorityEntity.singular,
      description: results?.hiringAuthority?.full_name,
      id: results?.hiringAuthority?.id,
      entityType: EntityType.HiringAuthority
    },
    {
      title: CandidateEntity.singular,
      description: results?.candidate?.personalInformation?.full_name,
      id: results?.candidate?.id,
      entityType: EntityType.Candidate
    },
    {
      title: CompanyEntity.singular,
      description: results?.joborder?.company?.name,
      id: results?.joborder?.company?.id,
      entityType: EntityType.Company
    }
  ].filter(item => item.id != null && Boolean(item.description) && Boolean(item.entityType));
};
